import React from 'react';
import { Box } from '@material-ui/core';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  // componentDidCatch(error, info) {
  //   this.setState({ hasError: true });
  // }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  render() {
    const { hasError } = this.state;
    const { children } = this.props;

    if (hasError) {
      return (
        <Box display="flex" justifyContent="center" alignItems="center" height="100%">
          <h2 style={{ color: '#a94442' }}>We are sorry something went wrong.</h2>
        </Box>
      )
    }
    // if(token == null || token == 0) {
    //   dispatch(logout())
    // }
    return children;
  }
}
